import { createApi } from "@reduxjs/toolkit/query/react";
import ApiUtils from "@/lib/ApiUtils";
import { Response } from "@/types/response/Response";
import { PageDTO } from "@/types/response/PageDTO";
import { TelegramNotificationDTO } from "@/types/message/telegram/TelegramNotificationDTO";
import { TelegramNotificationFilter } from "@/types/message/telegram/TelegramNotificationFilter";
import { WhatsAppNotificationDTO } from "@/types/message/whatsapp/WhatsAppNotificationDTO";
import { WhatsappNotificationFilter } from "@/types/message/whatsapp/WhatsAppNotificationFilter";
import { ExpoPushNotificationDTO } from "@/types/message/expo/ExpoPushNotificationDTO";
import { ExpoPushNotificationFilter } from "@/types/message/expo/ExpoPushNotificationFilter";

export const notificationApiV1 = createApi({
  reducerPath: "_notifications",
  baseQuery: ApiUtils.apiQuery("/v1"),
  tagTypes: ["_telegram_notifications", "_whatsapp_notifications", "_expo_push_notifications"],
  endpoints: (builder) => ({
    getTelegramNotifications: builder.query<
      Response<PageDTO<TelegramNotificationDTO>>,
      Partial<TelegramNotificationFilter>
    >({
      query: (params) => ({
        url: "notifications/telegram",
        method: "GET",
        params,
      }),
      providesTags: ["_telegram_notifications"],
    }),
    getWhatsAppNotifications: builder.query<
      Response<PageDTO<WhatsAppNotificationDTO>>,
      Partial<WhatsappNotificationFilter>
    >({
      query: (params) => ({
        url: "notifications/whatsapp",
        method: "GET",
        params,
      }),
      providesTags: ["_whatsapp_notifications"],
    }),
    getExpoPushNotifications: builder.query<
      Response<PageDTO<ExpoPushNotificationDTO>>,
      Partial<ExpoPushNotificationFilter>
    >({
      query: (params) => ({
        url: "notifications/push",
        method: "GET",
        params,
      }),
      providesTags: ["_expo_push_notifications"],
    }),
  }),
});

export const {
  useLazyGetWhatsAppNotificationsQuery,
  useLazyGetTelegramNotificationsQuery,
  useLazyGetExpoPushNotificationsQuery,
} = notificationApiV1;